
(function() {
  function init() {
    var labels = document.querySelectorAll('.form__label');
    var prenomInput = null;
    var prenomContainer = null;

    for (var i = 0; i < labels.length; i++) {
      if (labels[i].textContent.trim().match(/Pr[eé]nom/i)) {
        prenomContainer = labels[i].closest('.product-form__input') || labels[i].closest('.product__personalized-fields');
        prenomInput = prenomContainer ? prenomContainer.querySelector('input') : null;
        break;
      }
    }

    if (!prenomInput || !prenomContainer) return;

    var fieldDiv = prenomInput.closest('.field') || prenomInput.parentElement;

    var wrapper = document.createElement('div');
    wrapper.style.cssText = 'display:flex;gap:10px;align-items:center;flex-wrap:wrap;margin-top:8px';

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.id = 'personalize-btn';
    btn.textContent = "Voir l\u2019aper\u00e7u";
    btn.style.cssText = 'padding:10px 20px;background:#dd3939;color:#fff;border:none;border-radius:6px;font-size:14px;cursor:pointer;font-weight:600;white-space:nowrap';
    wrapper.appendChild(btn);
    fieldDiv.after(wrapper);

    var spinner = document.createElement('div');
    spinner.id = 'personalize-spinner';
    spinner.style.cssText = 'display:none;margin-top:16px;align-items:center;gap:8px';
    spinner.innerHTML = '<div style="width:24px;height:24px;border:3px solid #333;border-top-color:#dd3939;border-radius:50%;animation:perso-spin 1s linear infinite"></div><span>G\u00e9n\u00e9ration en cours\u2026</span>';

    var result = document.createElement('div');
    result.id = 'personalize-result';
    result.style.cssText = 'display:none;margin-top:16px';
    result.innerHTML = '<p style="font-weight:600;margin-bottom:8px">Aper\u00e7u avec votre pr\u00e9nom :</p><img id="personalize-img" src="" alt="Aper\u00e7u personnalis\u00e9" style="max-width:100%;border-radius:8px;border:1px solid #333" />';

    var errorDiv = document.createElement('div');
    errorDiv.id = 'personalize-error';
    errorDiv.style.cssText = 'display:none;margin-top:12px;color:#ff4444;font-size:14px';

    prenomContainer.appendChild(spinner);
    prenomContainer.appendChild(result);
    prenomContainer.appendChild(errorDiv);

    var style = document.createElement('style');
    style.textContent = '@keyframes perso-spin { to { transform: rotate(360deg); } }';
    document.head.appendChild(style);

    var productImages = window.__persoImages || [];
    var productImage = productImages.length > 1 ? productImages[1] : productImages[0];

    btn.addEventListener('click', function() {
      var name = prenomInput.value.trim();
      if (!name) {
        errorDiv.style.display = 'block';
        errorDiv.textContent = 'Veuillez entrer un pr\u00e9nom.';
        return;
      }
      errorDiv.style.display = 'none';
      result.style.display = 'none';
      spinner.style.display = 'flex';
      btn.disabled = true;
      btn.style.opacity = '0.6';

      fetch('https://tsw-store.netlify.app/api/personalize', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ imageUrl: productImage, name: name })
      })
      .then(function(r) { if (!r.ok) throw new Error('err'); return r.json(); })
      .then(function(d) {
        document.getElementById('personalize-img').src = d.imageUrl;
        result.style.display = 'block';
      })
      .catch(function() {
        errorDiv.style.display = 'block';
        errorDiv.textContent = "Impossible de g\u00e9n\u00e9rer l\u2019aper\u00e7u. R\u00e9essayez.";
      })
      .finally(function() {
        spinner.style.display = 'none';
        btn.disabled = false;
        btn.style.opacity = '1';
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
